export const rootUrl = process.env.REACT_APP_KISS_API_URL as string;
